import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Compact search + "New" toolbar for list views embedded in a modal (e.g.
 * port-modal's terminal/berth lists). Set `expandedSearch` to skip the
 * collapse-to-icon behavior and show the search input at full width instead.
 */
@Component({
  selector: 'app-list-toolbar',
  templateUrl: './list-toolbar.component.html',
  standalone: false,
})
export class ListToolbarComponent {
  @Input() searchPlaceholder = 'Search...';
  @Input() expandedSearch = false;
  @Input() showNewButton = true;
  @Input() newButtonTooltip = 'New';

  @Output() search = new EventEmitter<string>();
  @Output() newClick = new EventEmitter<void>();

  filter = '';
  searchOpen = false;

  toggleSearch(): void {
    if (this.searchOpen) {
      this.searchOpen = false;
      if (this.filter) {
        this.filter = '';
        this.search.emit('');
      }
    } else {
      this.searchOpen = true;
    }
  }

  handleSearch(value: string): void {
    this.filter = value;
    this.search.emit(value);
  }
}
